import React from 'react';
import { QuoteIcon } from 'lucide-react';
export const GallerySection = () => {
  const projects = [{
    id: 1,
    title: 'Sloep Stoffering',
    image: 'https://images.unsplash.com/photo-1605281317010-fe5ffe798166?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1744&q=80'
  }, {
    id: 2,
    title: 'Jacht Interieur',
    image: 'https://images.unsplash.com/photo-1566847438217-76e82d383f84?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1744&q=80'
  }, {
    id: 3,
    title: 'Bootkussens',
    image: 'https://images.unsplash.com/photo-1540946485063-a40da27545f8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80'
  }, {
    id: 4,
    title: 'Motorboot Renovatie',
    image: 'https://images.unsplash.com/photo-1564132943782-0f9a93af15d9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80'
  }];
  return <section className="py-20 bg-white" data-id="element-47">
      <div className="container mx-auto px-4" data-id="element-48">
        <div className="text-center mb-6" data-id="element-49">
          <div className="inline-flex items-center justify-center mb-4" data-id="element-50">
            <QuoteIcon className="text-[#234837] w-10 h-10 mr-2" data-id="element-51" />
            <p className="text-xl italic" data-id="element-52">
              "Onze sloep ziet er weer als nieuw uit – echt vakwerk."
            </p>
          </div>
          <p className="text-gray-600" data-id="element-53">– Klant uit Loosdrecht</p>
        </div>
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-54">
          Onze stoffering maakt het verschil
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-55">
          {projects.map(project => <div key={project.id} className="overflow-hidden rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300" data-id="element-56">
              <div className="relative h-64 md:h-80" data-id="element-57">
                <img src={project.image} alt={project.title} className="w-full h-full object-cover" data-id="element-58" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end" data-id="element-59">
                  <h3 className="text-white text-xl font-semibold p-4" data-id="element-60">
                    {project.title}
                  </h3>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};